import React from "react";
import Introduction from "./Introduction";
import Sections from "./Sections";

const Main = () => {
  return (
    <div>
      
     <Introduction/>
    
     
     <Sections/>
    </div>
  );
};

export default Main;
